import * as Select from '@radix-ui/react-select'
import { useAppStore } from '@store'
import React from 'react'
import clsx from 'clsx'

// Icono de chevron moderno
const ChevronDownIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 6L8 10L12 6'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const SelectItem = React.forwardRef<HTMLSelectElement, any>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <Select.Item
        {...props}
        ref={forwardedRef}
        className={clsx(
          'relative flex cursor-pointer select-none items-center rounded-md px-3 py-2.5 text-base leading-normal text-C/Color3 outline-none transition-colors',
          'data-[highlighted]:bg-gray-100 data-[state=checked]:bg-colorAtemporal data-[state=checked]:font-medium data-[highlighted]:text-C/Color3 data-[state=checked]:text-white',
          className,
        )}
      >
        <Select.ItemText className='text-base'>{children}</Select.ItemText>
        <Select.ItemIndicator className='absolute right-2 flex items-center text-white'>
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M13 4L6 11L3 8'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </Select.ItemIndicator>
      </Select.Item>
    )
  },
)

type Props = {
  isBusinessAccount: boolean
  setOrden: any
  orden: number
  texto: string
}

export function ProjectSort({ isBusinessAccount, setOrden, orden, texto }: Props) {
  // const placeholderText = ` ${"Fecha de última modificación"}`

  return (
    <Select.Root
      value={String(orden)}
      onValueChange={(val) => setOrden(Number(val))}
    >
      <Select.Trigger
        className={clsx(
          'group mb-2 ml-8 mr-1 mt-2 flex h-11 w-[510px] items-center justify-between rounded-lg border-2 border-colorAtemporal bg-white px-4 py-2.5 text-left shadow-sm',
          'transition-all duration-200 hover:shadow-md',
          'focus:outline-none focus:ring-2 focus:ring-colorAtemporal focus:ring-offset-1',
          'data-[state=open]:shadow-md',
        )}
      >
        <div className='flex items-center gap-2 text-base'>
          <span className='font-medium text-C/Color3'>{'Ordenar por'}</span>
          <Select.Value
            className='font-normal text-C/Color3 [&>span]:text-base'
            placeholder={`${'Fecha de última modificación'}`}
          />
        </div>
        <Select.Icon className='text-C/Color3 transition-transform duration-200 group-data-[state=open]:rotate-180'>
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          position='popper'
          className={clsx(
            'fixed z-50 ml-[280px] mt-2 min-w-[480px] overflow-hidden rounded-lg border-2 border-colorAtemporal bg-white shadow-lg',
            'animate-in fade-in-0 zoom-in-95',
          )}
          sideOffset={4}
        >
          <Select.ScrollUpButton className='flex h-6 cursor-default items-center justify-center bg-white text-C/Color3'>
            <ChevronDownIcon className='rotate-180' />
          </Select.ScrollUpButton>
          <Select.Viewport className='p-2'>
            <Select.Group>
              {isBusinessAccount && (
                <>
                  <SelectItem value='0'>{'Nombre'}</SelectItem>
                  <SelectItem value='1'>{'Apellidos'}</SelectItem>
                  <SelectItem value='2'>{'Email'}</SelectItem>
                  <SelectItem value='3'>{'Teléfono'}</SelectItem>
                  <div className='my-1 h-px bg-gray-200' />
                </>
              )}
              <SelectItem value='4'>{'Fecha de inicio'}</SelectItem>
              <SelectItem value='5'>{'Fecha de última modificación'}</SelectItem>
              <SelectItem value='6'>{'Estado'}</SelectItem>
            </Select.Group>
          </Select.Viewport>
          <Select.ScrollDownButton className='flex h-6 cursor-default items-center justify-center bg-white text-C/Color3'>
            <ChevronDownIcon />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  )
}
